import { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import { getStatus } from '../api/errors';
import { SessionProvider } from '../state/session';
import { LocationProvider } from '../state/location';
import { Toaster } from '../ui/Toast';

function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        refetchOnWindowFocus: false,
        // Client errors (4xx) won't succeed on retry; network blips and 5xx get one more try.
        retry: (failureCount, error) => {
          const status = getStatus(error);
          if (status && status >= 400 && status < 500) return false;
          return failureCount < 1;
        },
      },
      mutations: { retry: false },
    },
  });
}

export function AppProviders({ children }) {
  const [queryClient] = useState(createQueryClient);

  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <SessionProvider>
          <LocationProvider>
            {children}
            <Toaster />
          </LocationProvider>
        </SessionProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
}
